module.exports = __webpack_public_path__ + "static/img/PE.504cc890.png";